import { useFormik } from "formik";
import React from "react";
import { Card } from "react-bootstrap";
import { object, Schema, string } from "yup";
import { AssetApi, AssetDto } from "../../lib-api";
import DeleteIcon from "../../lib/mat-icons/delete";
import { useDebouncedEffect } from "../../util/hooks";
import { IconLink } from "../shared/icon-button";
import { TextFieldFormGroup } from "./groups/text-field-group";
import { AssetMeta } from "../../lib-api/models/AssetMeta";

export const assetValidationSchema: Schema<AssetMeta> = object({
  id: string().required(),
  caption: string().label("Beskrivelse").required(),
});

export const AssetCard: React.FC<{
  asset: AssetDto;
  disabled: boolean;
  removeAsset: (asset: AssetDto) => void;
  assetUpdated: (meta: AssetMeta) => void;
  api: AssetApi;
  rounded: boolean;
}> = (props) => {
  const { values, handleChange, submitForm, isValid, errors, touched } =
    useFormik<AssetMeta>({
      initialValues: {
        id: props.asset.id,
        caption: props.asset.caption ?? "",
      },
      validationSchema: assetValidationSchema,
      onSubmit: async (values) => {
        await props.api.editAsset({
          ...values,
          token: props.asset.token,
        });
      },
    });

  useDebouncedEffect(
    () => {
      if (isValid) {
        submitForm();
      }
      props.assetUpdated(values);
    },
    [values, isValid],
    1000
  );

  return (
    <Card>
      <Card.Header className="text-right">
        <IconLink onClick={() => props.removeAsset(props.asset)}>
          <DeleteIcon />
        </IconLink>
      </Card.Header>
      <Card.Img
        variant="top"
        src={props.asset.url}
        style={{ borderRadius: props.rounded ? "50%" : "" }}
      />
      <Card.Body className="p-2">
        <div className="form">
          <TextFieldFormGroup
            fieldName="caption"
            fieldDisplayName="Billedtekst"
            error={touched.caption ? errors.caption : undefined}
            value={values.caption}
            disabled={props.disabled}
            handleChange={handleChange}
            placeholder="Kort beskrivelse..."
          />
        </div>
      </Card.Body>
    </Card>
  );
};
